/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { Gender } from './Gender';
import {
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
    GenderToJSONTyped,
} from './Gender';
import type { CreateStudentRequest } from './CreateStudentRequest';
import {
    CreateStudentRequestFromJSON,
    CreateStudentRequestFromJSONTyped,
    CreateStudentRequestToJSON,
    CreateStudentRequestToJSONTyped,
} from './CreateStudentRequest';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateUserRequest
 */
export interface CreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    cellPhone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    password?: string | null;
    /**
     * 
     * @type {Gender}
     * @memberof CreateUserRequest
     */
    gender?: Gender | null;
    /**
     * 
     * @type {any}
     * @memberof CreateUserRequest
     */
    dateOfBirth?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    homePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    zip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    leadSource?: string | null;
    /**
     * 
     * @type {Array<CreateStudentRequest>}
     * @memberof CreateUserRequest
     */
    students?: Array<CreateStudentRequest> | null;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof CreateUserRequest
     */
    locationIds?: Array<ApiUserTasksGetPageParameter> | null;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof CreateUserRequest
     */
    workLocationIds?: Array<ApiUserTasksGetPageParameter> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    roleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    payrollId?: string | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateUserRequest
     */
    payRate?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {PaymentType}
     * @memberof CreateUserRequest
     */
    paymentType?: PaymentType | null;
}



/**
 * Check if a given object implements the CreateUserRequest interface.
 */
export function instanceOfCreateUserRequest(value: object): value is CreateUserRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    return true;
}

export function CreateUserRequestFromJSON(json: any): CreateUserRequest {
    return CreateUserRequestFromJSONTyped(json, false);
}

export function CreateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'cellPhone': json['cellPhone'],
        'password': json['password'] == null ? undefined : json['password'],
        'gender': json['gender'] == null ? undefined : GenderFromJSON(json['gender']),
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'address': json['address'] == null ? undefined : json['address'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'country': json['country'] == null ? undefined : json['country'],
        'leadSource': json['leadSource'] == null ? undefined : json['leadSource'],
        'students': json['students'] == null ? undefined : ((json['students'] as Array<any>).map(CreateStudentRequestFromJSON)),
        'locationIds': json['locationIds'] == null ? undefined : ((json['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'workLocationIds': json['workLocationIds'] == null ? undefined : ((json['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'roleName': json['roleName'] == null ? undefined : json['roleName'],
        'payrollId': json['payrollId'] == null ? undefined : json['payrollId'],
        'payRate': json['payRate'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['payRate']),
        'paymentType': json['paymentType'] == null ? undefined : PaymentTypeFromJSON(json['paymentType']),
    };
}

export function CreateUserRequestToJSON(json: any): CreateUserRequest {
    return CreateUserRequestToJSONTyped(json, false);
}

export function CreateUserRequestToJSONTyped(value?: CreateUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'cellPhone': value['cellPhone'],
        'password': value['password'],
        'gender': GenderToJSON(value['gender']),
        'dateOfBirth': value['dateOfBirth'],
        'homePhone': value['homePhone'],
        'address': value['address'],
        'zip': value['zip'],
        'city': value['city'],
        'state': value['state'],
        'country': value['country'],
        'leadSource': value['leadSource'],
        'students': value['students'] == null ? undefined : ((value['students'] as Array<any>).map(CreateStudentRequestToJSON)),
        'locationIds': value['locationIds'] == null ? undefined : ((value['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'workLocationIds': value['workLocationIds'] == null ? undefined : ((value['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'roleName': value['roleName'],
        'payrollId': value['payrollId'],
        'payRate': BalanceUnitStatementEntryDebitToJSON(value['payRate']),
        'paymentType': PaymentTypeToJSON(value['paymentType']),
    };
}

